import React from 'react';
import { PaperPage } from '../common/PaperPage';
import VouchersTable from './VouchersTable';
import { useVouchersFilter } from './VouchersFilter/VouchersFilterContext';

const VouchersPage = () => {
  const { isFilterActive } = useVouchersFilter();
  return (
    <PaperPage isHighlighted={isFilterActive}>
      <VouchersTable />
    </PaperPage>
  );
};

export default VouchersPage;
